// Hero-banner subtitel kleiner maken op mobiel/tablet
function resizeHeroSubtitle() {
  const subtitle = document.querySelector(".banner__text.rte.subtitle");
  if (!subtitle) return;

  if (window.innerWidth <= 1024) {
    // Mobiel/tablet: forceer klein lettertype
    subtitle.style.fontSize = "24px";  // basis grootte, CSS clamp zorgt voor schaal
    subtitle.style.lineHeight = "1.2";
  } else {
    // Desktop: reset naar originele grootte
    subtitle.style.fontSize = "";
    subtitle.style.lineHeight = "";
  }
}

// Initial check bij laden
document.addEventListener("DOMContentLoaded", resizeHeroSubtitle);

// Herbereken bij schermresizen
window.addEventListener("resize", resizeHeroSubtitle);
